

























































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class BlogName extends Vue {
  get snippet1 () {
    return 'yarn add @vue/composition-api'
  }

  get snippet2 () {
    return `"dependencies": {
  "vue": "^2.6.12" // Used to be "vue": "^2.6.10",
  ...
},
"devDependencies": {
  "vue-template-compiler": "^2.6.12" // If you use a template compiler, update this to match your vue version
}`
  }

  get snippet3 () {
    return `import Vue from "vue";
import VueCompositionApi from "@vue/composition-api";
 
Vue.use(VueCompositionApi);`
  }

  get snippet4 () {
    return `import Vue from "vue";
import "./composition-api";...`
  }

  get snippet5 () {
    return `import { ref, computed } from "@vue/composition-api";
import { TaskData, TaskStatus } from "@/models/task-data";
 
const tasks = ref([]);
 
const add = (task: TaskData) => {
  tasks.value.push(task);
};
 
const remove = (taskId: string) => {
  tasks.value = tasks.value.filter((task: TaskData) => task.id !== taskId);
};
 
const removeAll = () => {
  tasks.value = [];
};
 
const updateTaskStatus = (taskId: string, status: TaskStatus) => {
  const task = tasks.value.find((task: TaskData) => task.id === taskId);
 
  if (task) {
    task.propsData.status = status;
  }
};
 
const hasTasks = computed(() => tasks.value.length > 0);
const taskCount = computed(() => tasks.value.length);
 
const taskTray = {
  tasks,
  add,
  remove,
  removeAll,
  updateTaskStatus,
  hasTasks,
  taskCount
};
 
export { taskTray };`
  }
}
